'use client'
import { FC, PropsWithChildren } from 'react'

import NavBar from '~/src/components/shared/NavBar'

import Sidebar from '~/src/components/Sidebar'
import { IntegratedTrackingBasePath, NetworkBasePath } from '~/constants/urls'
import { tw } from '~/lib/utils'

import { LayoutProps } from '~/app/types'

const getLogoHref = (path: string | undefined): string | undefined => {
  if (!path) {
    return undefined
  }

  if (path.startsWith(IntegratedTrackingBasePath)) {
    return IntegratedTrackingBasePath
  }

  if (path.startsWith(NetworkBasePath)) {
    return IntegratedTrackingBasePath
  }

  return undefined
}

const DesktopLayout: FC<PropsWithChildren<LayoutProps>> = ({
  currentPage,
  availablePages,
  children,
  onOpenSettings,
}) => {
  const logoHref = getLogoHref(currentPage?.path)

  return (
    <div
      className={tw(
        "grid h-screen w-screen grid-cols-[62px_auto] grid-rows-[60px_auto] [grid-template-areas:'sidebar_navbar'_'sidebar_main']",
        !currentPage?.title && "[grid-template-areas:'sidebar_main'_'sidebar_main']"
      )}
    >
      <Sidebar pages={availablePages} onOpenSettings={onOpenSettings} />
      {currentPage?.title && (
        <NavBar
          logo={currentPage.logo}
          logoHref={logoHref}
          title={currentPage.title}
          onOpenSettings={onOpenSettings}
        />
      )}
      <div className="min-h-0 overflow-hidden [grid-area:main]">{children}</div>
    </div>
  )
}

export default DesktopLayout
